// extracted by mini-css-extract-plugin
module.exports = {"guide":"BeginToOffer_guide__1nAZS","intro":"BeginToOffer_intro__38DlR","intro_1":"BeginToOffer_intro_1__2OvPe"};